module.exports = __webpack_public_path__ + "img/md.mdb51b6be.svg";